<template>
  <div class="candidateCard">
    <div class="candidateCard__candidate">
      <input
        type="checkbox"
        :value="candidateId"
        :checked="isSelected"
        @input="$emit('toggleCandidate', candidateId)"
      />

      <router-link
        :to="{
          name: prospectDetailsRouteName,
          params: {
            iMId,
            prospectId: candidateId,
          },
        }"
      >
        <div class="d-flex align-items-center">
          <CandidateAvatar
            :avatar-id="avatarId"
            variant="circle"
            has-border
            class="ml-3"
          />

          <span class="ml-2">
            {{ name }}
          </span>
        </div>
      </router-link>
    </div>

    <hl-Tag v-if="unreadMessages" class="candidateCard__tag mt-2" variant="primary" shouldShowDot>
      <span v-if="unreadMessages === 1"> 1 ulest melding </span>

      <span v-else> {{ unreadMessages }} uleste meldinger </span>
    </hl-Tag>

    <hr />

    <div class="candidateCard__detailsTopRow">
      <div>
        <p class="mb-1">
          <strong>Dato</strong>
        </p>
        <hl-Date :date="date" />
      </div>

      <div>
        <p class="candidateCard__detailsTopRow__rightText mb-1">
          <strong>Status</strong>
        </p>

        <hl-Tag :variant="candidateStatusVariant" shouldShowDot>
          {{ candidateStatusText }}
        </hl-Tag>
      </div>
    </div>

    <div class="candidateCard__detailsBottomRow mt-4">
      <div>
        <p class="m-0">
          <strong>Rangering</strong>
        </p>

        <hl-RatingStars :value="rank" @newScore="$emit('updateProspectScore', { candidateId, rank: $event })" />
      </div>

      <div>
        <p class="candidateCard__detailsBottomRow__rightText mb-1">
          <strong>Kredittsjekk</strong>
        </p>

        <hl-Tag :variant="creditCheckStatusVariant" isLargeBorderRadius>
          <div class="d-flex align-items-center">
            <Icon :name="creditCheckStatusIcon" class="mr-2" />
            {{ creditCheckStatusText }}
          </div>
        </hl-Tag>
      </div>
    </div>

    <router-link
      :to="{
        name: prospectDetailsRouteName,
        params: {
          landlordId,
          rentalObjectId,
          iMId,
          prospectId: candidateId,
        },
      }"
      v-slot="{ href, navigate }"
      custom
    >
      <hl-Button :href="href" variant="extra" size="sm" outline class="mt-4" @click="navigate">
        <div class="d-flex align-items-center ml-1">
          <strong>Profil</strong>
          <strong>
            <i class="budicon-chevron-right h5" />
          </strong>
        </div>
      </hl-Button>
    </router-link>
  </div>
</template>

<script>
import Vue from 'vue';
import Icon, { IconName, IconSize } from '@modules/design-system/components/Icon';
import Tag from '@modules/husleie-framework/src/components/forms/inputs/tags/Tag.vue';
import Date from '@modules/husleie-framework/src/components/time/Date.vue';
import CandidateAvatar from '@/components/CandidateAvatar.vue';

export default Vue.extend({
  name: 'CandidateCard',
  data() {
    return {
      IconName,
      IconSize,
    };
  },
  props: {
    landlordId: {
      type: Number,
      required: true,
    },
    rentalObjectId: {
      type: Number,
      required: true,
    },
    iMId: {
      type: String,
      required: true,
    },
    candidateId: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    candidateStatusVariant: {
      type: String,
      required: true,
    },
    candidateStatusText: {
      type: String,
      required: true,
    },
    rank: {
      type: Number,
      required: true,
    },
    creditCheckStatusVariant: {
      type: String,
      required: true,
    },
    creditCheckStatusIcon: {
      type: String,
      required: true,
    },
    creditCheckStatusText: {
      type: String,
      required: true,
    },
    unreadMessages: {
      type: Number,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    prospectDetailsRouteName: {
      type: String,
      required: true,
    },
    avatarId: {
      type: String,
      required: false,
    },
  },
  components: {
    'hl-Tag': Tag,
    'hl-Date': Date,
    Icon,
    CandidateAvatar,
  },
});
</script>

<style lang="scss" scoped>
.candidateCard {
  padding: 1.5rem;
  border: 1px solid $gray-200;
  border-radius: 6px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);
  height: 100%;
}
.candidateCard__candidate {
  display: flex;
  align-items: center;
}
.candidateCard__tag {
  width: fit-content;
}
.candidateCard__candidate a {
  color: unset;
}
.candidateCard__candidate input[type='checkbox'] {
  width: 20px;
  height: 20px;
}
.candidateCard__detailsTopRow {
  display: flex;
  justify-content: space-between;
}
.candidateCard__detailsTopRow__rightText {
  text-align: right;
  margin-right: 0.5rem;
}
.candidateCard__detailsBottomRow {
  display: flex;
  flex-direction: column;
  justify-content: initial;
  align-items: center;
  text-align: center;
  gap: 1rem 0rem;
}

@media (min-width: 400px) {
  .candidateCard__detailsBottomRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
    gap: 0;
  }
  .candidateCard__detailsBottomRow__rightText {
    text-align: right;
    margin-right: 0.5rem;
  }
}
</style>
